import { call, put, delay, takeEvery } from "redux-saga/effects";
import {
  hideContractorsListLoader,
  setContractorProfile,
  setContractorsList,
  setErrorContractorProfile,
  showContractorsListLoader,
  setContractorProfileLoader,
} from "./actions";
import {
  getErrorMessage,
  showErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";
import {
  ADD_CONTRACTOR,
  DELETE_CONTRACTOR,
  GET_CONTRACTOR_PROFILE,
  GET_CONTRACTORS_LIST,
  UPDATE_CONTRACTOR_PROFILE,
} from "./actionTypes";
import {
  deleteContracts,
  getContracts,
  getContractsProfile,
  patchContractsProfile,
  postContracts,
} from "../../helpers/jwt_helper";

function* onGetContractorList({ payload: data }) {
  try {
    yield put(showContractorsListLoader());
    let response = yield call(getContracts, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
    });
    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          description: i.description === "string" ? "" : i.description,
        })),
      };
    } else {
      response = {
        results: response,
      };
    }
    yield put(setContractorsList(response));
    yield put(hideContractorsListLoader());
  } catch (error) {
    yield put(hideContractorsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddContractor({ payload: { contractor, data } }) {
  try {
    yield put(showContractorsListLoader());
    yield call(postContracts, contractor);
    // yield call(onGetContractorList, { payload: data });
    yield put(hideContractorsListLoader());
    showSuccessMessage("Contractor has been added");
  } catch (error) {
    yield put(hideContractorsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteContractor({ payload: { id, data } }) {
  try {
    yield put(showContractorsListLoader());
    yield call(deleteContracts, id);
    yield call(onGetContractorList, { payload: data });
    yield put(hideContractorsListLoader());
    showSuccessMessage("Contractor has been deleted");
  } catch (error) {
    yield put(hideContractorsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetContractorProfile({ payload: id }) {
  try {
    yield put(setContractorProfileLoader());
    yield put(setErrorContractorProfile(false));
    let response = yield call(getContractsProfile, id);
    yield put(setContractorProfile(response));
    yield put(setContractorProfileLoader());
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorContractorProfile(true));
    } else {
      showErrorMessage(getErrorMessage(error));
    }
    yield put(setContractorProfileLoader());
  }
}

function* onUpdateContractorProfile({ payload: { id, contractor, data } }) {
  try {
    yield put(showContractorsListLoader());
    yield call(patchContractsProfile, id, contractor);
    // yield call(onGetContractorList, { payload: data });
    yield put(hideContractorsListLoader());
    showSuccessMessage("Contractor has been updated");
  } catch (error) {
    yield put(hideContractorsListLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* contractorListSaga() {
  yield takeEvery(GET_CONTRACTORS_LIST, onGetContractorList);
  yield takeEvery(DELETE_CONTRACTOR, onDeleteContractor);
  yield takeEvery(ADD_CONTRACTOR, onAddContractor);
  yield takeEvery(GET_CONTRACTOR_PROFILE, onGetContractorProfile);
  yield takeEvery(UPDATE_CONTRACTOR_PROFILE, onUpdateContractorProfile);
}

export default contractorListSaga;
